import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'influencerSubCategories',
  urlRoot: '/influencer_sub_categories'
})
